import Vue from 'vue';
import { ANNIVERSARY_BANNERS } from '../config';
import type { Anniversary15BannerVariant } from '../types';
import Anniversary15PromoBanner from '../ui/Anniversary15PromoBanner.vue';

const CONTAINER_SELECTOR = '.js-anniversary15-promo-banner';

const mountedContainers = new WeakSet<HTMLElement>();

const createBannerInstance = (variant: Anniversary15BannerVariant): Vue =>
    new Vue({
        render: (h) => h(Anniversary15PromoBanner, { props: { variant } }),
    });

export const createAnniversary15PromoBannerElement = (variant: Anniversary15BannerVariant): HTMLElement => {
    const instance = createBannerInstance(variant).$mount();
    return instance.$el as HTMLElement;
};

const isBannerVariant = (value?: string): value is Anniversary15BannerVariant =>
    !!value && Object.keys(ANNIVERSARY_BANNERS).includes(value);

const parseVariant = (value?: string): Anniversary15BannerVariant => (isBannerVariant(value) ? value : 'main');

const mountAllBanners = (): void => {
    document.querySelectorAll<HTMLElement>(CONTAINER_SELECTOR).forEach((container) => {
        if (mountedContainers.has(container)) return;
        mountedContainers.add(container);
        createBannerInstance(parseVariant(container.dataset.variant)).$mount(container);
    });
};

export default function initAnniversary15PromoBanner(): void {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => mountAllBanners(), { once: true });
    } else {
        mountAllBanners();
    }
}
